const routes = [
  {
    path: "/parametros-ensinos-cargas",
    name: "parametros-ensinos-cargas",
    meta: {
      allowedPermissions: ["parametro_ensino_carga_list"],
      breadCrumb: "Lotação de Servidores - Tabelas Básicas",
    },
    component: () =>
      import("@/views/ParametrosEnsinosCargas/ParametrosEnsinosCargasHome.vue"),
  },

  {
    path: "/parametros-ensinos-cargas/novo",
    name: "parametros-ensinos-cargas-novo",
    meta: {
      allowedPermissions: ["parametro_ensino_carga_insert"],
      breadCrumb: "Lotação de Servidores - Tabelas Básicas",
    },
    component: () =>
      import("@/views/ParametrosEnsinosCargas/ParametrosEnsinosCargasCad.vue"),
  },

  {
    path: "/parametros-ensinos-cargas/editar/:id",
    name: "parametros-ensinos-cargas-editar",
    meta: {
      allowedPermissions: ["parametro_ensino_carga_update"],
      breadCrumb: "Lotação de Servidores - Tabelas Básicas",
    },
    component: () =>
      import("@/views/ParametrosEnsinosCargas/ParametrosEnsinosCargasEdit.vue"),
  },
];

export default routes;
